class WorldFeed extends HTMLElement {
  #filterButtons;
  #feedItems;

  connectedCallback() {
    this.#filterButtons = this.querySelectorAll('[data-filter-type]');
    this.#feedItems = this.querySelectorAll('[data-feed-type]');

    this.#filterButtons.forEach((button) => {
      button.addEventListener('click', () => this.#handleFilterClick(button));
    });
  }

  #handleFilterClick(clickedButton) {
    const filterType = clickedButton.getAttribute('data-filter-type');

    this.#filterButtons.forEach((button) => {
      button.setAttribute('aria-selected', button === clickedButton ? 'true' : 'false');
    });

    this.#feedItems.forEach((item) => {
      const isVisible = filterType === 'all' || item.getAttribute('data-feed-type') === filterType;
      item.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
  }
}

customElements.define('world-feed', WorldFeed);
